import { Component, Input, OnInit } from "@angular/core";
import { CustomerVariantSkuSubCategory } from "../../models";

@Component({
  selector: "app-item-request-wizard-sku-request-more-info",
  standalone: false,
  templateUrl: "./item-request-wizard-sku-request-more-info.component.html",
  styleUrl: "./item-request-wizard-sku-request-more-info.component.scss",
  host: {
    "[style.display]": "display",
  },
})
export class ItemRequestWizardSkuRequestMoreInfoComponent implements OnInit {
  display: string = "none";

  @Input() subCategory: CustomerVariantSkuSubCategory;
  @Input() canMakeRequests: boolean;

  ngOnInit(): void {
    this.display =
      this.subCategory.requiresMoreInfo &&
      this.subCategory.customerRequestSupported &&
      !this.subCategory.customerUploadSupported &&
      this.canMakeRequests
        ? "block"
        : "none";
  }
}
